module.exports = __webpack_public_path__ + "static/media/promotion.d1d967ff.png";